import { CollectionAccessTypes } from "../../redux/features/appData";

export const prettyCollectionAccessType = (
  accessType: CollectionAccessTypes | undefined
) => {
  switch (accessType) {
    case CollectionAccessTypes.PRIVATE:
      return "Private";
    case CollectionAccessTypes.TEAM:
      return "Team";
    case CollectionAccessTypes.RESTRICTED:
      return "Restricted";
    default:
      return "unknown";
  }
};
